import {Component, OnInit} from '@angular/core';
import {
    DynamicFormReadyEvent
} from '../../../../../projects/mydocma/dynamic-form/src/lib/events/dynamic-form-ready.event';
import {UntypedFormGroup} from '@angular/forms';
import {DynamicFormConfig} from '../../../../../projects/mydocma/dynamic-form/src/lib/dynamic-form/dynamic-form.config';
import {formConfig} from '../data/config-form';

@Component({
    selector: 'app-layouts',
    templateUrl: './layouts.component.html',
    styleUrls: ['./layouts.component.scss']
})
export class LayoutsComponent implements OnInit {

    public formData: DynamicFormReadyEvent;
    public formGroup: UntypedFormGroup;
    public formConfig: DynamicFormConfig;

    public selectedLayoutName;

    public ngOnInit() {
        this.selectedLayoutName = 'layout2';
        this.formConfig = formConfig;
    }

    public onReadyEvent(param: DynamicFormReadyEvent) {
        this.formData = param;
        this.formGroup = param.dynamicFormService.formGroup;
        this.formData.dynamicFormEventsService.onControlBlur.subscribe((value: DynamicFormConfig) => {
            if (value.name === 'number1') {
                console.log(value);
            }
        });
        this.formData.dynamicFormEventsService.onControlClick.subscribe((value: DynamicFormConfig) => {
            if (value.name === 'button1') {
             this.formData.dynamicFormService.updateFieldConfig({
                 name: 'select23',hidden: true
             })
            }
        });

    }

    public onConfigChange(event) {
        this.selectedLayoutName = event.value;
    }
}

